import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

export const alertKey = new PluginKey("citationAlerts");
const CITE_RE = /(\(\d{4}\)\s*\d+\s*SCC\s*\d+|AIR\s*\d{4}\s*[A-Z]{2,4}\s*\d+|\d{4}\s*SCC\s*OnLine\s*[A-Za-z]{2,5}\s*\d+|\d{4}\s*INSC\s*\d+)/gi;
const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 60);

// C1: restrained inline flags beside flagged citations; the alert data comes from the server, nothing is removed.
function build(doc, alerts) {
  if (!alerts?.length) return DecorationSet.empty;
  const byAuth = new Map(alerts.filter((a) => a.authorityId).map((a) => [a.authorityId, a]));
  const byCite = new Map(alerts.map((a) => [norm(a.citation), a]));
  const decos = [];
  const widget = (pos, a) => Decoration.widget(pos, () => { const el = document.createElement("span"); el.className = `nyk-flag nyk-flag-${a.decision ? "reviewed" : a.level.toLowerCase()}`; el.title = a.decision ? `Reviewed: ${a.decision.action}` : "Authority requires review"; el.dataset.alertKey = a.key; el.dataset.testid = "citation-flag"; el.textContent = "⚑"; return el; }, { side: 1, key: `${a.key}-${pos}` });
  doc.descendants((node, pos) => {
    if (node.type.name === "citation") {
      const a = byAuth.get(node.attrs.authorityId) || byCite.get(norm(node.attrs.label));
      if (a) { decos.push(Decoration.node(pos, pos + node.nodeSize, { class: `nyk-flagged-${a.decision ? "reviewed" : a.level.toLowerCase()}` })); decos.push(widget(pos + node.nodeSize, a)); }
      return false;
    }
    if (node.isText) {
      let m; CITE_RE.lastIndex = 0;
      while ((m = CITE_RE.exec(node.text))) { const a = byCite.get(norm(m[0])); if (a) { decos.push(Decoration.inline(pos + m.index, pos + m.index + m[0].length, { class: `nyk-flagged-${a.decision ? "reviewed" : a.level.toLowerCase()}` })); decos.push(widget(pos + m.index + m[0].length, a)); } }
    }
  });
  return DecorationSet.create(doc, decos);
}

export const CitationAlerts = Extension.create({
  name: "citationAlerts",
  addStorage() { return { alerts: [] }; },
  addCommands() { return { setCitationAlerts: (alerts) => ({ tr, dispatch, editor }) => { editor.storage.citationAlerts.alerts = alerts; tr.setMeta(alertKey, alerts); if (dispatch) dispatch(tr); return true; } }; },
  addProseMirrorPlugins() {
    const storage = this.storage;
    return [new Plugin({
      key: alertKey,
      state: { init: (_, state) => build(state.doc, storage.alerts), apply: (tr, old, _o, newState) => tr.getMeta(alertKey) || tr.docChanged ? build(newState.doc, storage.alerts) : old },
      props: { decorations(state) { return this.getState(state); } },
    })];
  },
});
